import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grid grid-cols-8 my-4 gap-y-5 gap-x-4" }
const _hoisted_2 = { class: "flex flex-col gap-y-1" }
const _hoisted_3 = { class: "flex flex-row gap-x-1" }
const _hoisted_4 = { class: "font-normal text-14px text-gray-lp-600" }
const _hoisted_5 = { class: "font-normal text-14px text-black-lp-100" }
const _hoisted_6 = { class: "flex flex-row gap-x-1" }
const _hoisted_7 = { class: "font-normal text-14px text-gray-lp-600" }
const _hoisted_8 = { class: "flex gap-x-1 flex-row items-center font-normal text-14px text-black-lp-100" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_10 = { class: "flex flex-col gap-y-1" }
const _hoisted_11 = { class: "flex flex-row gap-x-1" }
const _hoisted_12 = { class: "font-normal text-14px text-gray-lp-600" }
const _hoisted_13 = { class: "font-normal text-14px text-black-lp-100" }
const _hoisted_14 = { class: "flex flex-row gap-x-1" }
const _hoisted_15 = { class: "font-normal text-14px text-gray-lp-600" }
const _hoisted_16 = { class: "flex gap-x-1 flex-row items-center font-normal text-14px text-black-lp-100" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_18 = { class: "flex flex-col gap-y-1" }
const _hoisted_19 = { class: "flex flex-row gap-x-1" }
const _hoisted_20 = { class: "font-normal text-14px text-gray-lp-600" }
const _hoisted_21 = { class: "font-normal text-14px text-black-lp-100" }
const _hoisted_22 = { class: "flex flex-row gap-x-1" }
const _hoisted_23 = { class: "font-normal text-14px text-gray-lp-600" }
const _hoisted_24 = { class: "flex gap-x-1 flex-row items-center font-normal text-14px text-black-lp-100" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_26 = { class: "flex flex-col gap-y-1" }
const _hoisted_27 = { class: "flex flex-row gap-x-1" }
const _hoisted_28 = { class: "font-normal text-14px text-gray-lp-600" }
const _hoisted_29 = { class: "font-normal text-14px text-black-lp-100" }
const _hoisted_30 = { class: "flex flex-row gap-x-1" }
const _hoisted_31 = { class: "font-normal text-14px text-gray-lp-600" }
const _hoisted_32 = { class: "flex gap-x-1 flex-row items-center font-normal text-14px text-black-lp-100" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_34 = { class: "flex flex-col gap-y-1" }
const _hoisted_35 = { class: "flex flex-row gap-x-1" }
const _hoisted_36 = { class: "font-normal text-14px text-gray-lp-600" }
const _hoisted_37 = { class: "font-normal text-14px text-black-lp-100" }
const _hoisted_38 = { class: "flex flex-row gap-x-1" }
const _hoisted_39 = { class: "font-normal text-14px text-gray-lp-600" }
const _hoisted_40 = { class: "flex gap-x-1 flex-row items-center font-normal text-14px text-black-lp-100" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" : ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "p-4" }, {
    default: _withCtx(() => [
      _createVNode(_component_Title, {
        label: _ctx.$t('dexAssessment.contactInformation')
      }, null, 8, ["label"]),
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: _ctx.$t('dexAssessment.courier')
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("dexAssessment.name")), 1),
                _createVNode("p", _hoisted_5, " : " + _toDisplayString(_ctx.data.daDeliveryCourierName || "-"), 1)
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("dexAssessment.contact")), 1),
                _createVNode("div", _hoisted_8, [
                  _hoisted_9,
                  (_ctx.data.daDeliveryCourierPhone)
                    ? (_openBlock(), _createBlock(_component_Icons, {
                        key: 0,
                        name: "whatsapp",
                        class: "cursor-pointer w-5 h-5",
                        style: {"color":"#36b37e"},
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToWhatsapp(_ctx.data.daDeliveryCourierPhone)))
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.data.daDeliveryCourierPhone || "-"), 1)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: _ctx.$t('dexAssessment.console')
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("dexAssessment.name")), 1),
                _createVNode("p", _hoisted_13, " : " + _toDisplayString(_ctx.data.daAssignedPartnerName || "-"), 1)
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("dexAssessment.contact")), 1),
                _createVNode("div", _hoisted_16, [
                  _hoisted_17,
                  (_ctx.data.daAssignedPartnerPhone)
                    ? (_openBlock(), _createBlock(_component_Icons, {
                        key: 0,
                        name: "whatsapp",
                        class: "cursor-pointer w-5 h-5",
                        style: {"color":"#36b37e"},
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToWhatsapp(_ctx.data.daAssignedPartnerPhone)))
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.data.daAssignedPartnerPhone || "-"), 1)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: _ctx.$t('dexAssessment.courierCaptain')
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _createVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("dexAssessment.name")), 1),
                _createVNode("p", _hoisted_21, " : " + _toDisplayString(_ctx.data.daDeliveryCaptainCourierName || "-"), 1)
              ]),
              _createVNode("div", _hoisted_22, [
                _createVNode("p", _hoisted_23, _toDisplayString(_ctx.$t("dexAssessment.contact")), 1),
                _createVNode("div", _hoisted_24, [
                  _hoisted_25,
                  (_ctx.data.daDeliveryCaptainCourierPhone)
                    ? (_openBlock(), _createBlock(_component_Icons, {
                        key: 0,
                        name: "whatsapp",
                        class: "cursor-pointer w-5 h-5",
                        style: {"color":"#36b37e"},
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToWhatsapp(_ctx.data.daDeliveryCaptainCourierPhone)))
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.data.daDeliveryCaptainCourierPhone || "-"), 1)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: _ctx.$t('dexAssessment.recipient')
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                _createVNode("p", _hoisted_28, _toDisplayString(_ctx.$t("dexAssessment.name")), 1),
                _createVNode("p", _hoisted_29, " : " + _toDisplayString(_ctx.data.daRecipientName || "-"), 1)
              ]),
              _createVNode("div", _hoisted_30, [
                _createVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("dexAssessment.contact")), 1),
                _createVNode("div", _hoisted_32, [
                  _hoisted_33,
                  (_ctx.data.daRecipientPhone)
                    ? (_openBlock(), _createBlock(_component_Icons, {
                        key: 0,
                        name: "whatsapp",
                        class: "cursor-pointer w-5 h-5",
                        style: {"color":"#36b37e"},
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToWhatsapp(_ctx.data.daRecipientPhone)))
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.data.daRecipientPhone || "-"), 1)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_DataWrapper, {
          class: "col-span-2",
          label: _ctx.$t('dexAssessment.sender')
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_34, [
              _createVNode("div", _hoisted_35, [
                _createVNode("p", _hoisted_36, _toDisplayString(_ctx.$t("dexAssessment.name")), 1),
                _createVNode("p", _hoisted_37, " : " + _toDisplayString(_ctx.data.daSenderName || "-"), 1)
              ]),
              _createVNode("div", _hoisted_38, [
                _createVNode("p", _hoisted_39, _toDisplayString(_ctx.$t("dexAssessment.contact")), 1),
                _createVNode("div", _hoisted_40, [
                  _hoisted_41,
                  (_ctx.data.daSenderPhone)
                    ? (_openBlock(), _createBlock(_component_Icons, {
                        key: 0,
                        name: "whatsapp",
                        class: "cursor-pointer w-5 h-5",
                        style: {"color":"#36b37e"},
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToWhatsapp(_ctx.data.daSenderPhone)))
                      }))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.data.daSenderPhone || "-"), 1)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["label"])
      ])
    ]),
    _: 1
  }))
}